<template>
  <div id="app">
    <Navbar />
    <Content />
    <Footer />
  </div>
</template>
<script>
  import Navbar from '@/components/templates/NavbarCms.vue'
  import Content from '@/components/templates/Content.vue'
  import Footer from '@/components/templates/Footer.vue'
  export default {
    name: 'AppLayout',
    components: {
      Navbar,
      Content,
      Footer
    },
  }
</script>